// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#org-unit #org-content #form-filter-request {
    padding-right: 260px;
}

#org-unit #org-content #main-btn {
    top: -78px;
}

#org-unit #org-content.inner-container .filter-inputs {
    grid-template-columns: auto auto auto !important;
}

#org-unit #org-content .div-dept-display_status {
    border: 3px solid #c5bfbf;
}

#org-unit #org-content .div-dept-deleted {
    border: 3px solid #dd3030;
}

#org-unit #org-content .div-dept.hover .btn-setting {
    display: block;
}

#org-unit #org-content .div-dept.hover .btn-add {
    display: none;
}

#org-unit #org-content .btn-setting {
    display: none;
}

#org-unit #org-content .btn-add-division, #org-content .btn-add-branch {
    line-height: inherit;
    border-radius: 5px;
    margin-top: 8px;
    width: 100%;
    height: auto;
    padding: 5px 5px;
    background: #fcf4b9;
    color: #000;
}

#org-unit #org-content .btn-add-dept, #org-content .btn-add-org {
    line-height: inherit;
    border-radius: 5px;
    margin-top: 8px;
    width: 100%;
    height: auto;
    padding: 5px 5px;
    background: #ffeb3b;
    color: #000;
}

#org-unit #org-content .btn-edit {
    line-height: inherit;
    border-radius: 5px;
    margin-top: 8px;
    width: 100%;
    height: auto;
    padding: 5px 5px;
    background: #ffcc34;
    color: #000;
}

#org-unit #org-content .btn-add {
    position: absolute;
    right: 4px;
    top: 50%;
    margin-top: -10px;
    background-color: #ffcc34;
    display: block;
}`, "",{"version":3,"sources":["webpack://./src/components/OrgUnit/org.unit.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;AACxB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;AAClB","sourcesContent":["#org-unit #org-content #form-filter-request {\r\n    padding-right: 260px;\r\n}\r\n\r\n#org-unit #org-content #main-btn {\r\n    top: -78px;\r\n}\r\n\r\n#org-unit #org-content.inner-container .filter-inputs {\r\n    grid-template-columns: auto auto auto !important;\r\n}\r\n\r\n#org-unit #org-content .div-dept-display_status {\r\n    border: 3px solid #c5bfbf;\r\n}\r\n\r\n#org-unit #org-content .div-dept-deleted {\r\n    border: 3px solid #dd3030;\r\n}\r\n\r\n#org-unit #org-content .div-dept.hover .btn-setting {\r\n    display: block;\r\n}\r\n\r\n#org-unit #org-content .div-dept.hover .btn-add {\r\n    display: none;\r\n}\r\n\r\n#org-unit #org-content .btn-setting {\r\n    display: none;\r\n}\r\n\r\n#org-unit #org-content .btn-add-division, #org-content .btn-add-branch {\r\n    line-height: inherit;\r\n    border-radius: 5px;\r\n    margin-top: 8px;\r\n    width: 100%;\r\n    height: auto;\r\n    padding: 5px 5px;\r\n    background: #fcf4b9;\r\n    color: #000;\r\n}\r\n\r\n#org-unit #org-content .btn-add-dept, #org-content .btn-add-org {\r\n    line-height: inherit;\r\n    border-radius: 5px;\r\n    margin-top: 8px;\r\n    width: 100%;\r\n    height: auto;\r\n    padding: 5px 5px;\r\n    background: #ffeb3b;\r\n    color: #000;\r\n}\r\n\r\n#org-unit #org-content .btn-edit {\r\n    line-height: inherit;\r\n    border-radius: 5px;\r\n    margin-top: 8px;\r\n    width: 100%;\r\n    height: auto;\r\n    padding: 5px 5px;\r\n    background: #ffcc34;\r\n    color: #000;\r\n}\r\n\r\n#org-unit #org-content .btn-add {\r\n    position: absolute;\r\n    right: 4px;\r\n    top: 50%;\r\n    margin-top: -10px;\r\n    background-color: #ffcc34;\r\n    display: block;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
